import Vue from 'vue'
import NuxtLoading from './components/nuxt-loading.vue'

import '../assets/css/general.styl'

import _309dff80 from '../layouts/article.vue'
import _77180f1e from '../layouts/blank.vue'
import _0ca635c3 from '../layouts/calculator_gray_background.vue'
import _3dc80910 from '../layouts/calculator.vue'
import _549182fe from '../layouts/common/redesign-v1/sfc-footer.vue'
import _3b8b5392 from '../layouts/common/redesign-v1/sfc-header-no-ad.vue'
import _35df4f94 from '../layouts/common/redesign-v1/sfc-header-no-nav.vue'
import _4e0e1454 from '../layouts/common/redesign-v1/sfc-header-student-loans.vue'
import _5767aff0 from '../layouts/common/redesign-v1/sfc-header.vue'
import _27a692fc from '../layouts/common/redesign-v1/sfc-menu-mobile-v2.vue'
import _2be3054d from '../layouts/common/redesign-v1/sfc-menu-mobile.vue'
import _c268deb2 from '../layouts/common/redesign-v1/sfc-menu-v2.vue'
import _872040fc from '../layouts/common/redesign-v1/sfc-menu.vue'
import _76e2aea3 from '../layouts/common/sfc-dfp.vue'
import _7186768f from '../layouts/common/sfc-gdpr-banner.vue'
import _bcf6d64c from '../layouts/common/sfc-gtm-body.vue'
import _38c8be8c from '../layouts/common/sfc-header-no-nav.vue'
import _35118fd8 from '../layouts/common/sfc-header-slim-no-ad.vue'
import _1a9656d6 from '../layouts/common/sfc-header-slim-student-loans.vue'
import _47319df2 from '../layouts/common/sfc-header-slim.vue'
import _6574f217 from '../layouts/common/sfc-heap.vue'
import _274e486e from '../layouts/common/sfc-menu-slim-v2.vue'
import _2267c56c from '../layouts/common/sfc-sentry.vue'
import _2a5e5f98 from '../layouts/common/sfc-sidebar-ads.vue'
import _31e924de from '../layouts/common/sfc-wisepops.vue'
import _60124484 from '../layouts/default_404.vue'
import _3ecaff9b from '../layouts/default_no_ad_modal.vue'
import _b03c50a6 from '../layouts/default_no_ad.vue'
import _59ff9cce from '../layouts/default_no_footer_kpmg.vue'
import _9008a7b6 from '../layouts/default_no_footer.vue'
import _6f6c098b from '../layouts/default.vue'
import _e74d0dce from '../layouts/empty_default.vue'
import _2d23adba from '../layouts/form.vue'
import _4d674ef2 from '../layouts/intro_to_529s.vue'
import _003d53a1 from '../layouts/licensed_financial_aid_calculator.vue'
import _080e8e5e from '../layouts/portals.vue'
import _1d547b53 from '../layouts/prudential-white-label.vue'
import _7cb554a2 from '../layouts/redesign-v1/best-plans.vue'
import _6d558585 from '../layouts/redesign-v1/blank_only_logo.vue'
import _5bff9093 from '../layouts/redesign-v1/default.vue'
import _29edabcd from '../layouts/redesign-v1/home.vue'
import _3f23108c from '../layouts/redesign-v1/plan-details.vue'
import _1464eb63 from '../layouts/redesign-v1/state.vue'
import _5ad369c8 from '../layouts/redesign-v1/subscribe.vue'
import _d5e0c542 from '../layouts/savings-center.vue'
import _ca016bd4 from '../layouts/v2/blank_only_logo.vue'
import _37886412 from '../layouts/v2/blank.vue'
import _40accfd9 from '../layouts/v2/default_no_sidebar.vue'
import _229b7624 from '../layouts/v2/default.vue'

const layouts = { "_article": _309dff80,"_blank": _77180f1e,"_calculator_gray_background": _0ca635c3,"_calculator": _3dc80910,"_common/redesign-v1/sfc-footer": _549182fe,"_common/redesign-v1/sfc-header-no-ad": _3b8b5392,"_common/redesign-v1/sfc-header-no-nav": _35df4f94,"_common/redesign-v1/sfc-header-student-loans": _4e0e1454,"_common/redesign-v1/sfc-header": _5767aff0,"_common/redesign-v1/sfc-menu-mobile-v2": _27a692fc,"_common/redesign-v1/sfc-menu-mobile": _2be3054d,"_common/redesign-v1/sfc-menu-v2": _c268deb2,"_common/redesign-v1/sfc-menu": _872040fc,"_common/sfc-dfp": _76e2aea3,"_common/sfc-gdpr-banner": _7186768f,"_common/sfc-gtm-body": _bcf6d64c,"_common/sfc-header-no-nav": _38c8be8c,"_common/sfc-header-slim-no-ad": _35118fd8,"_common/sfc-header-slim-student-loans": _1a9656d6,"_common/sfc-header-slim": _47319df2,"_common/sfc-heap": _6574f217,"_common/sfc-menu-slim-v2": _274e486e,"_common/sfc-sentry": _2267c56c,"_common/sfc-sidebar-ads": _2a5e5f98,"_common/sfc-wisepops": _31e924de,"_default_404": _60124484,"_default_no_ad_modal": _3ecaff9b,"_default_no_ad": _b03c50a6,"_default_no_footer_kpmg": _59ff9cce,"_default_no_footer": _9008a7b6,"_default": _6f6c098b,"_empty_default": _e74d0dce,"_form": _2d23adba,"_intro_to_529s": _4d674ef2,"_licensed_financial_aid_calculator": _003d53a1,"_portals": _080e8e5e,"_prudential-white-label": _1d547b53,"_redesign-v1/best-plans": _7cb554a2,"_redesign-v1/blank_only_logo": _6d558585,"_redesign-v1/default": _5bff9093,"_redesign-v1/home": _29edabcd,"_redesign-v1/plan-details": _3f23108c,"_redesign-v1/state": _1464eb63,"_redesign-v1/subscribe": _5ad369c8,"_savings-center": _d5e0c542,"_v2/blank_only_logo": _ca016bd4,"_v2/blank": _37886412,"_v2/default_no_sidebar": _40accfd9,"_v2/default": _229b7624 }

export default {
  head: {"title":"sfc_frontend","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"https:\u002F\u002Fweb-resources.savingforcollege.com\u002Fimages\u002Ffavicon.ico"}],"script":[{"hid":"mcjs","innerHTML":"!function (c,h,i,m,p){m=c.createElement(h),p=c.getElementsByTagName(h)[0],m.async=1,m.src=i,p.parentNode.insertBefore(m,p)}(document,\"script\",\"https:\u002F\u002Fchimpstatic.com\u002Fmcjs-connected\u002Fjs\u002Fusers\u002F0a20469f2040c0b79be9ec2a8\u002F54fb981018ba7ad56770e00e9.js\");"}],"__dangerouslyDisableSanitizers":["script"],"style":[]},

  render(h, props) {
    const loadingEl = h('NuxtLoading', { ref: 'loading' })
    const layoutEl = h(this.layout || 'nuxt')
    const templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [ layoutEl ])

    const transitionEl = h('transition', {
      props: {
        name: 'layout',
        mode: 'out-in'
      },
      on: {
        beforeEnter(el) {
          // Ensure to trigger scroll event after calling scrollBehavior
          window.$nuxt.$nextTick(() => {
            window.$nuxt.$emit('triggerScroll')
          })
        }
      }
    }, [ templateEl ])

    return h('div', {
      domProps: {
        id: '__nuxt'
      }
    }, [
      loadingEl,
      transitionEl
    ])
  },
  data: () => ({
    isOnline: true,
    layout: null,
    layoutName: ''
  }),
  beforeCreate() {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt)
  },
  created() {
    // Add this.$nuxt in child instances
    Vue.prototype.$nuxt = this
    // add to window so we can listen when ready
    if (process.client) {
      window.$nuxt = this
      this.refreshOnlineStatus()
      // Setup the listeners
      window.addEventListener('online', this.refreshOnlineStatus)
      window.addEventListener('offline', this.refreshOnlineStatus)
    }
    // Add $nuxt.error()
    this.error = this.nuxt.error
  },

  mounted() {
    this.$loading = this.$refs.loading
  },
  watch: {
    'nuxt.err': 'errorChanged'
  },

  computed: {
    isOffline() {
      return !this.isOnline
    }
  },
  methods: {
    refreshOnlineStatus() {
      if (process.client) {
        if (typeof window.navigator.onLine === 'undefined') {
          // If the browser doesn't support connection status reports
          // assume that we are online because most apps' only react
          // when they now that the connection has been interrupted
          this.isOnline = true
        } else {
          this.isOnline = window.navigator.onLine
        }
      }
    },

    errorChanged() {
      if (this.nuxt.err && this.$loading) {
        if (this.$loading.fail) this.$loading.fail()
        if (this.$loading.finish) this.$loading.finish()
      }
    },

    setLayout(layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      this.layoutName = layout
      this.layout = layouts['_' + layout]
      return this.layout
    },
    loadLayout(layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      return Promise.resolve(layouts['_' + layout])
    }
  },
  components: {
    NuxtLoading
  }
}
